import type { SVGProps } from 'react';

export type IconName = 'menu' | 'close' | 'search' | 'star' | 'chart' | 'chevron' | 'ticket' | 'user' | 'globe' | 'football' | 'cricket' | 'tennis' | 'basketball' | 'hockey' | 'volleyball' | 'table-tennis' | 'esports' | 'casino' | 'live' | 'play' | 'plus' | 'trash';

const paths: Record<IconName, React.ReactNode> = {
  menu: <><path d="M3 6h18M3 12h18M3 18h18" /></>,
  close: <><path d="M5 5l14 14M19 5L5 19" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="m16 16 5 5" /></>,
  star: <><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z" /></>,
  chart: <><path d="M4 19V9m6 10V5m6 14v-7m4 7H2" /></>,
  chevron: <><path d="m7 9 5 5 5-5" /></>,
  ticket: <><path d="M4 6h16v4a2 2 0 0 0 0 4v4H4v-4a2 2 0 0 0 0-4Z" /><path d="M12 7v10" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" /></>,
  football: <><circle cx="12" cy="12" r="9" /><path d="m12 8 4 3-2 5h-4l-2-5Zm-7 1 3 2m8 0 3-2M8 18l2-2m6 2-2-2" /></>,
  cricket: <><path d="m7 19 8-15 3 2-8 15ZM5 4l4 2M4 20h16" /></>,
  tennis: <><circle cx="12" cy="12" r="9" /><path d="M5.8 5.8c4 4 8.4 8.4 12.4 12.4M18.2 5.8c-4 4-4 8.4 0 12.4" /></>,
  basketball: <><circle cx="12" cy="12" r="9" /><path d="M12 3v18M3 12h18M5.6 5.6c5 1 11.8 7.8 12.8 12.8M18.4 5.6c-5 1-11.8 7.8-12.8 12.8" /></>,
  hockey: <><path d="M6 4v11c0 3 2 5 5 5h8v-4h-7c-1 0-2-1-2-2V4Z" /></>,
  volleyball: <><circle cx="12" cy="12" r="9" /><path d="M12 3c1 6 5 7 9 7M5 18c5-3 7-7 6-15M3 11c5 1 9 4 11 9" /></>,
  'table-tennis': <><circle cx="9" cy="9" r="5" /><path d="m13 13 7 7M16 8h4" /></>,
  esports: <><path d="M5 8h14l2 10-5-1-2-3h-4l-2 3-5 1Z" /><path d="M8 11v4m-2-2h4m6-2v.01m2 2v.01" /></>,
  casino: <><rect x="4" y="4" width="16" height="16" rx="3" /><circle cx="9" cy="9" r="1" /><circle cx="15" cy="15" r="1" /><path d="m8 16 8-8" /></>,
  live: <><circle cx="12" cy="12" r="2" /><path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7M5.5 5.5a9 9 0 0 0 0 13M18.5 5.5a9 9 0 0 1 0 13" /></>,
  play: <><path d="m8 5 11 7-11 7Z" /></>,
  plus: <><path d="M12 5v14M5 12h14" /></>,
  trash: <><path d="M5 7h14M9 7V4h6v3m2 0-1 14H8L7 7m3 4v6m4-6v6" /></>,
};

export function Icon({ name, ...props }: SVGProps<SVGSVGElement> & { name: IconName }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      {paths[name]}
    </svg>
  );
}
